import { API_BASE_URL } from "../config"

// Sube una imagen al servidor (endpoint público) y devuelve la URL pública generada.
// No se envía token ni header Content-Type: el navegador arma el multipart con su boundary.
export const uploadImagen = async (file) => {
  const formData = new FormData()
  formData.append("file", file)

  const response = await fetch(`${API_BASE_URL}/api/sucursal-fotografias/upload`, {
    method: "POST",
    body: formData,
  })

  if (!response.ok) {
    let detalle = ""
    try {
      const data = await response.json()
      detalle = data.error || ""
    } catch {
      detalle = await response.text()
    }
    throw new Error(detalle || `Error ${response.status} al subir la imagen`)
  }

  const data = await response.json()
  return data.url
}
